export const linkResolver = doc => {
  if (doc.type === 'product') {
    return `/product/${doc.uid}`;
  }

  if (doc.type === 'solution') {
    return `/solution/${doc.uid}`;
  }

  if (doc.type === 'pricing_segment') {
    return `/pricing/${doc.uid}`;
  }

  if (doc.type === 'customer') {
    return `/customer/${doc.uid}`;
  }

  if (doc.type === 'resources') {
    return `/resources/`;
  }

  if (doc.type === 'topic') {
    return `/resources/${doc.uid}`;
  }

  if (doc.type === 'post') {
    return `/post/${doc.uid}`;
  }

  if (doc.type === 'person') {
    return `/bio/${doc.uid}`;
  }

  if (doc.type === 'about_us') {
    return `/about/`;
  }

  if (doc.type === 'careers') {
    return `/careers/`;
  }

  if (doc.type === 'events') {
    return `/events/`;
  }

  if (doc.type === 'event') {
    return `/event/${doc.uid}`;
  }

  if (doc.type === 'in_the_media') {
    return `/in-the-media/`;
  }

  if (doc.type === 'contact_us') {
    return `/contact-us/`;
  }

  if (doc.type === 'simple_page') {
    return `/${doc.uid}`;
  }

  if (doc.type === 'dashboard') {
    return `/${doc.uid}`;
  }

  if (doc.type === 'landing') {
    return `/landing/${doc.uid}`;
  }

  if (doc.type === 'preview') {
    return `/preview/${doc.uid}`;
  }

  return '/';
};
